export default __webpack_public_path__ + "static/wingBrave-d5c03656582815efbaa7dec652e0dcda.png";